import './App.css';
import ReactPricingCard from './Component/ReactPricingCard';
function App() {
  return (
    <div  className="pricing py-5">
      {/* <PricingCard /> */}
      <ReactPricingCard />

    </div>
  );
}

export default App;